import { render, staticRenderFns } from "./designSprint.vue?vue&type=template&id=b8b8ae3c&scoped=true&"
import script from "./designSprint.vue?vue&type=script&lang=js&"
export * from "./designSprint.vue?vue&type=script&lang=js&"
import style0 from "./designSprint.vue?vue&type=style&index=0&id=b8b8ae3c&scoped=true&lang=css&"
import style1 from "./designSprint.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b8ae3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b8ae3c')) {
      api.createRecord('b8b8ae3c', component.options)
    } else {
      api.reload('b8b8ae3c', component.options)
    }
    module.hot.accept("./designSprint.vue?vue&type=template&id=b8b8ae3c&scoped=true&", function () {
      api.rerender('b8b8ae3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/workspace/prekickoff/designSprint.vue"
export default component.exports